import React from 'react';

const EngineFilterIcon = (props: any) => (
  <svg
    width={props.width || '20'}
    height={props.height || '20'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.03508 15.7803L5.77055 15.5112L5.39315 15.5112L4.18649 15.5112C3.57898 15.5112 3.08649 15.0187 3.08649 14.4112L3.08649 9.49187C3.08649 8.88435 3.57898 8.39187 4.18649 8.39187L5.44481 8.39187L5.81301 8.39187L6.07563 8.13379L9.71056 4.56175C9.91744 4.35846 10.1962 4.2451 10.4863 4.24634L19.7399 4.28595C20.3456 4.28854 20.8352 4.78026 20.8352 5.38594L20.8353 7.61137L20.8352 7.61658L20.7884 15.6988C20.7867 15.9917 20.6683 16.2717 20.4594 16.477L17.4197 19.4641C17.2122 19.668 16.9324 19.7814 16.6415 19.7795L10.3791 19.7387L10.3732 20.6387L10.3791 19.7387C10.0865 19.7368 9.80673 19.6184 9.60166 19.4097L6.03508 15.7803Z"
      strokeWidth="1.8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 7H13L11.5 12.5L13.5033 12.5409L12.5 17L17 10.3333H14.9333L16 7Z"
      fill={props.fill || '#000000'}
    />
  </svg>
);

export default EngineFilterIcon;
